import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary-screen" style={{ minHeight: "100vh", background: "#0A0A0A", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px", fontFamily: "sans-serif" }}>
        <div style={{ maxWidth: 460, textAlign: "center" }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>🔧</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: "#F2B705", marginBottom: 8 }}>Something went wrong</h1>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.6)", lineHeight: 1.6, marginBottom: 20 }}>
            One part of the page hit an unexpected error. Your data is safe — nothing was lost or changed.
            Reload to keep working, and if this keeps happening, let support know what you clicked.
          </p>
          <button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            style={{ background: "#F2B705", color: "#000", fontWeight: 700, border: "none", borderRadius: 8, padding: "12px 28px", fontSize: 14, cursor: "pointer" }}>
            Reload Page
          </button>
          <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 16, wordBreak: "break-word" }}>{String(this.state.error?.message || this.state.error).slice(0, 200)}</p>
        </div>
      </div>
    );
  }
}
